<div id="workflow-modal">
  <div class="modal-header">
    <h3 class="modal-title">
      {{ title }}
      <i class="fa fa-times pull-right" (click)="close()"></i>
      <i class="fa pull-right"
         [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
         style="margin-right: 10px"
         (click)="minimise = !minimise"></i>
    </h3>
  </div>

  <div class="modal-body" [hidden]="minimise">
    <form novalidate>
      <div class="row">
        <div class="col-md-4">
          <div class="form-group">
            <label>Name *</label>
            <input class="form-control" [(ngModel)]="name" name="name"
                   [disabled]="disableAll"
                   [class.error-field]="isNameMissing()" />
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label>Description</label>
            <textarea class="form-control" placeholder="Add Message"
                      [(ngModel)]="description" name="description"
                      [disabled]="disableAll"
                      style="height: 85px;"></textarea>
          </div>
        </div>
        <div class="form-group col-md-4">
          @if (node.is_custom === '1') {
<div class="form-group">
            <label>Active</label>
            <select class="form-control" [(ngModel)]="isActive" name="isActive"
                    [disabled]="disableAll">
              @for (opt of selectedActiveOptions; track $index) {
<option [value]="opt.value">{{ opt.name }}</option>
}
            </select>
          </div>
}
          <div class="form-group">
            <label>Current Version</label>
            <input class="form-control" [value]="versionNumber" readonly
                   style="background-color: #ccc !important;" />
          </div>
        </div>
      </div>

      <!-- Version History -->
      @if (versionNumList.length > 0) {
<div class="version-table-wrapper">
        <table class="table">
          <thead>
            <tr>
              <th></th>
              <th style="width: 25%">Name</th>
              <th>Description</th>
              <th>IsActive</th>
              <th>Version Number</th>
            </tr>
          </thead>
          <tbody>
            @for (ver of versionNumList; track $index) {
<tr>
              <td>
                <input type="radio" name="verNum"
                       [value]="ver.version_number"
                       [checked]="ver.is_Active == 1"
                       (click)="changeVersion(ver)" />
              </td>
              <td>{{ ver.name }}</td>
              <td>{{ ver.description }}</td>
              <td>{{ ver.is_Active }}</td>
              <td>{{ ver.version_number }}</td>
            </tr>
}
          </tbody>
        </table>
      </div>
}
    </form>
  </div>

  <div class="modal-footer" [hidden]="minimise">
    <button type="button" class="btn btn-primary" (click)="save()" [disabled]="saving">
      Save @if (saving) {
<i class="fa fa-spinner fa-spin"></i>
}
    </button>
    <button type="button" class="btn btn-warning" (click)="reset()">Reset</button>
    <button type="button" class="btn btn-danger" (click)="close()">Cancel</button>
  </div>
</div>
